export const TID = {
  // login
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginRemember: "login-remember-checkbox",
  loginForgot: "login-forgot-link",
  loginError: "login-error",

  // app shell
  sidebar: "app-sidebar",
  sidebarLogo: "sidebar-logo",
  topbar: "app-topbar",
  userMenu: "user-menu-btn",
  logoutBtn: "logout-btn",

  // nav
  navDashboard: "nav-dashboard",
  navCampaigns: "nav-campaigns",
  navCurveLibrary: "nav-curve-library",
  navUploadCurve: "nav-upload-curve",
  navVendors: "nav-vendors",
  navDDF: "nav-ddf",
  navBudgetSensitivity: "nav-budget-sensitivity",
  navOptimizer: "nav-optimizer",
  navReports: "nav-reports",
  navSettings: "nav-settings",

  // dashboard
  kpiTotalBudget: "kpi-total-budget",
  kpiTvBudget: "kpi-tv-budget",
  kpiOlvBudget: "kpi-olv-budget",
  kpiCombinedReach: "kpi-combined-reach",
  kpiTvReach: "kpi-tv-reach",
  kpiOlvReach: "kpi-olv-reach",
  kpiEffCprp: "kpi-eff-cprp",
  kpiDdf: "kpi-ddf",
  kpiSaving: "kpi-saving",

  // upload
  uploadCurveName: "upload-curve-name",
  uploadTargetAudience: "upload-target-audience",
  uploadUniverseSize: "upload-universe-size",
  uploadNotes: "upload-notes",
  uploadTvDropzone: "upload-tv-dropzone",
  uploadOlvDropzone: "upload-olv-dropzone",
  uploadTvInput: "upload-tv-input",
  uploadOlvInput: "upload-olv-input",
  uploadSubmit: "upload-submit-btn",
  uploadReset: "upload-reset-btn",

  // optimizer
  optCurveSelect: "opt-curve-select",
  optTotalBudget: "opt-total-budget",
  optTvBudget: "opt-tv-budget",
  optOlvBudget: "opt-olv-budget",
  optTvCpp: "opt-tv-cpp",
  optOlvEcpm: "opt-olv-ecpm",
  optDdf: "opt-ddf",
  optInDemo: "opt-in-demo",
  optViewability: "opt-viewability",
  optRun: "opt-run-btn",
  optSave: "opt-save-btn",
  optReset: "opt-reset-btn",
  optResult: "opt-result-panel",
};
